import React from "react";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ConfirmDialog } from "src/apps/commons/dataDisplays";
import { PartnerUserId } from "../types";
import Form from "./EditForm";
import { constants } from "../utils";
import { useUpdate } from "../hooks";

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.default,
    padding: "16px"
  }
}));

interface Props {
  id: PartnerUserId;
}

const FormContainers: React.FC<Props> = props => {
  const { id } = props;
  const classes = useStyles();

  const {
    saving,
    fetching,
    confirmDialogState,
    data,
    handleSave,
    handleCloseDialog
  } = useUpdate(id);

  return (
    <Paper className={classes.root}>
      <Form
        isLoading={fetching}
        isSaving={saving}
        data={data}
        onSubmit={handleSave}
      />

      <ConfirmDialog
        title={`ยืนยันการแก้ไข ${constants.label}?`}
        open={confirmDialogState.open}
        onClose={handleCloseDialog}
        onConfirm={confirmDialogState.onConfirm}
      />
    </Paper>
  );
};

export default FormContainers;
